import { Box, Typography, Button } from '@mui/material';
import moment from 'moment';
import { useState } from 'react';

const CommentCardList = ({ comments }: any) => {
  const [showAll, setShowAll] = useState(false);

  const displayedComments = showAll ? comments : comments?.slice(0, 2);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        margin: 'auto',
      }}>
      {console.log('comments', comments)}
      {displayedComments?.map((comment) => (
        <Box
          key={comment._id}
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'flex-start',
            gap: 2,
            p: 2,

            borderRadius: '8px',
            boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.1)',
          }}>
          <Box sx={{ flexGrow: 1 }}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'center',
                gap: 1,
                mb: 1,
              }}>
              <img
                alt={comment?.createdBy?.name}
                src={comment?.createdBy?.avatar}
                style={{
                  width: 30,
                  height: 30,
                  borderRadius: '50%',
                  objectFit: 'contain',
                }}
              />
              <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                {comment.createdBy.name}
              </Typography>

              <Typography variant="caption" sx={{ color: 'gray' }}>
                {moment(comment.createdAt).format('MMMM D YYYY - HH:mm:ss')}
              </Typography>
            </Box>

            {/* Comment Text */}
            <div
              style={{
                marginTop: '8px',
                color: '#555',
                lineHeight: '1.6',
                backgroundColor: '#f9f9f9',
                padding: '8px',
                borderRadius: '4px',
              }}
              dangerouslySetInnerHTML={{ __html: comment.description }}
            />

            {/* Attachments */}
            {comment.attachments && comment.attachments.length > 0 && (
              <Box sx={{ mt: 2 }}>
                <Typography variant="subtitle2" sx={{ mb: 1 }}>
                  Attachments:
                </Typography>
                <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                  {comment.attachments.map((attachment, index) => (
                    <Box
                      key={attachment}
                      component="a"
                      href={attachment}
                      target="_blank"
                      rel="noopener noreferrer">
                      <img
                        src={attachment}
                        alt={`Attachment ${index + 1}`}
                        style={{
                          maxWidth: '100px',
                          maxHeight: '100px',
                          objectFit: 'cover',
                          borderRadius: '4px',
                          border: '1px solid #eee',
                        }}
                      />
                    </Box>
                  ))}
                </Box>
              </Box>
            )}
          </Box>
        </Box>
      ))}

      <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
        {comments?.length > 3 && (
          <Button
            onClick={() => setShowAll(!showAll)}
            sx={{ alignSelf: 'center', mt: 1 }}>
            {showAll ? 'Show Less' : `See ${comments.length - 2} More Comments`}
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default CommentCardList;
